import { Text, VStack } from '@chakra-ui/react';

import MarketplaceCard from '../../MarketplaceCard';
import ExploreBuyoutButton from './ExploreBuyoutButton';

type KeepTheCarCardProps = {
  model?: string | null;
  dealId: string;
  leadId: string;
};

const KeepTheCarCard = ({ model, dealId, leadId }: KeepTheCarCardProps) => (
  <MarketplaceCard px="20px" py="18px">
    <VStack align="stretch" spacing="8px">
      <Text fontSize="15px" fontWeight="700" color="leaseEndBlue">
        Rather keep the car?
      </Text>
      <Text fontSize="12.5px" color="charcoal" lineHeight="1.5">
        You can buy out your lease instead: the lease ends and the title goes in your name.
      </Text>
      <ExploreBuyoutButton
        source="keep_card"
        model={model}
        dealId={dealId}
        leadId={leadId}
        variant="quietOutline"
        alignSelf="flex-start"
        mt="4px"
      />
    </VStack>
  </MarketplaceCard>
);

export default KeepTheCarCard;
